import { BaseRequestEndpoints } from '@trukt/types/BaseRequestEndpoints';
import { fromArrayToCSV } from '@trukt/utils/fromArrayToCSV';

import { AxiosInstance } from 'axios';
import { JobPostSearchRequest, JobPostSearchResponse } from './JobPostService.types';

export class JobPostService implements Pick<BaseRequestEndpoints, 'search'> {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  search(request: JobPostSearchRequest) {
    return this.instance.get<JobPostSearchResponse>('/job-posts', {
      params: {
        ...request.queryParams,
        contractStatus: fromArrayToCSV(request.queryParams.contractStatus),
      },
    });
  }
}
